'use client';
import { Card } from '@ahafood/ui/components/card';
import { Image } from '@ahafood/ui/components/image';
import ForYouHeader from '../session/for-you-header';
import ForYouItemList from '../session/for-you-item-list';
import AmoriSidebar from '@/app/[locale]/amori/amori-sidebar';
import { useIsMobile } from '@/lib/is-mobile';

export default function ForYouPageContent() {
  const isMobile = useIsMobile();

  // Mobile layout
  if (isMobile) {
    return (
      <div
        style={{
          backgroundImage: 'url(/static/icons/for-you-background.svg)',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundAttachment: 'fixed',
        }}
        className="min-h-screen p-4"
      >
        <ForYouHeader />
        <div className="bg-transparent h-28 w-full"></div>
        <div className="bg-transparent rounded-lg mt-4">
          <ForYouItemList />
        </div>
      </div>
    );
  }

  // Desktop layout
  return (
    <div className="min-h-screen bg-white">
      {/* Compact Header - Desktop */}
      <div className="border-b border-neutral-10 bg-white sticky top-0 z-40">
        <div className="max-w-screen-2xl mx-auto px-12 py-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-[#0D4073]">FOR YOU</h1>
              <Image
                src="/static/icons/ai-gen.svg"
                alt="AI"
                width={32}
                height={32}
                className="object-contain"
              />
            </div>
            <p className="text-sm text-neutral-60">
              AI gợi ý theo sở thích của bạn
            </p>
          </div>
        </div>
      </div>

      {/* 2-Column Content */}
      <div className="max-w-screen-2xl mx-auto px-12 py-8">
        <div className="grid grid-cols-[1fr_380px] xl:grid-cols-[1fr_420px] gap-8">
          {/* Main Content - Left */}
          <main className="min-w-0">
            <ForYouItemList />
          </main>

          {/* Sidebar - Right */}
          <aside className="sticky top-24 h-[calc(100vh-120px)] space-y-6">
            {/* Amori Chat */}
            <AmoriSidebar defaultCollapsed={false} />

            {/* Quick Actions */}
            <Card className="p-6 bg-gradient-to-br from-[#FFF7F2] to-white border border-neutral-10">
              <h3 className="font-bold text-neutral-90 mb-4">
                Chat với Amori tại đây...
              </h3>
              <div className="space-y-3 text-sm text-neutral-70">
                <p>Chào! Bạn cần tư vấn gì không?</p>
                <p>Tôi đang ở Hà Nội. Gợi ý món ăn nào?</p>
              </div>
            </Card>
          </aside>
        </div>
      </div>
    </div>
  );
}
